import { doMock } from "~/utils/mock";

export default function ({ $axios, redirect, $config }) {
  // 模拟数据
  if($config.axios.isMock) {
    doMock($axios);
  }
}